import { useNavigate } from "react-router-dom";
import { updateAuthenticationState } from "../Store/Slices/authStates";
import { useDispatch } from "react-redux";
import { REDIRECT_KEY } from "../constents/text";
import useRedirect from "./Auth/useRedirect";



const useOnAuthFaild = () => {
    const Navigate = useNavigate();
    const dispatch = useDispatch();
    const { redirectUrlSetter} = useRedirect();

    return () => {
        redirectUrlSetter();
        window.sessionStorage.removeItem('token');
        dispatch(updateAuthenticationState(false));
        Navigate('/auth/login');
    }
}

export default useOnAuthFaild;